import React, { Component } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Card
} from "@material-ui/core";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { getUser, getReviewRating } from "../../../../actions/users";
import { formatPhoneNumber } from "../../../../utils";
import { CircularProgress } from '@material-ui/core'
import StarIcon from "@material-ui/icons/Star";
import { formatDate } from "../../../../utils";
import license_default from "../../../../assets/images/license_default.png";
import Img from 'react-fix-image-orientation'

class AddRealtorModal extends Component {
  state = {
    photoID: '',
    buyerInfo: '',
    loading: false,
    showReview: false,
    reviewList: [],
    address: null,
    pageSize: 50
  };

  componentDidMount() {
    this.getUser();
  }

  getUser = () => {
    const { dispatch, buyerId, showReview = false, address } = this.props;
    this.setState({ loading: true, showReview, address });
    if (buyerId) {
      dispatch(getUser(buyerId))
        .then(res => {
          let secureUrl = '';
          if (res.photo_id) {
            const { secure_url } = JSON.parse(res.photo_id);
            secureUrl = secure_url;
          }
          this.setState({ loading: false });
          this.setState({ photoID: secureUrl, buyerInfo: res });
        })
    }
    if (showReview) {
      this.setState({ loading: true });
      const { pageNumber, pageSize } = this.state;
      this.props
        .dispatch(getReviewRating(buyerId, pageNumber, pageSize))
        .then(response => {
          this.setState({
            reviewList: response.data,
            count: response.count,
            loading: false
          });
        })
    }
  };

  closeModal = () => {
    this.props.dispatch({ type: "VIEW_BUYER_DETAILS", payload: false });
  };

  render() {
    const { classes } = this.props;
    const { first_name, last_name, phone } = this.state.buyerInfo;
    return (
      <Dialog
        onClose={this.closeModal}
        open={this.props.open}
        className={classes.realtorPopup}
      >
        <DialogTitle
          className={[classes.popupTitle, classes.popupBuyerTitle].join(" ")}
          onClose={this.closeModal}
        >
          Buyer Details
          <CloseIcon onClick={this.closeModal} />
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <div className={classes.popupLoader}>
            {this.state.loading && <CircularProgress size={60} />}
          </div>
          {this.state.buyerInfo && <div className={classes.buyerPopupDetails}>
            <div>
              <Typography variant="h3">Basic Information</Typography>
              <Card className={classes.Infocard}>
                <Typography variant="h6">Full Name</Typography>
                <Typography variant="h5">{first_name + ' ' + last_name}</Typography>
              </Card>
              <Card className={classes.Infocard}>
                <Typography variant="h6">Mobile Number</Typography>
                <Typography variant="h5">{formatPhoneNumber(phone.substring(2))}</Typography>
              </Card>
              {this.state.address && <Card className={classes.Infocard}>
                <Typography variant="h6">Location</Typography>
                <Typography variant="h5">{this.state.address}</Typography>
              </Card>}
            </div>

            <div>
              <Typography variant="h3">Document <span>(Image of Face)</span></Typography>
              <Card className={classes.Infocard}>
                <Img src={this.state.photoID || license_default} alt="Driving Licence" />
                <Typography variant="h4">(Image of Face)</Typography>
              </Card>
            </div>
          </div>}

          {/* Buyer Review start here */}
          {!this.state.loading && this.state.showReview && this.state.buyerInfo && <div className={classes.buyerReviewSection}>
            <Typography variant="h4">
              All Reviews <span>({this.state.count || 0})</span>{" "}
            </Typography>
            {this.state.reviewList.map(review => {
              const { id, rating, review: reviewText, created, reviewer_fist_name: fname, reviewer_last_name: lname } = review;
              return (
                <div className={classes.ReviewBlock} key={id}>
                  <div className={classes.RatingWrap}>
                    <Typography variant="h5" className={classes.ReviewTitle}>
                      {fname + ' ' + lname}
                    </Typography>

                    <div className={classes.Rating}>
                      {new Array(rating).map(() => {
                        return (<StarIcon className={classes.ActiveRating} />)
                      })
                      }
                    </div>
                  </div>

                  <div>
                    <Typography variant="p" className={classes.ReviewContent}>
                      {reviewText}
                    </Typography>
                    <small className={classes.ReviewDate}>{formatDate(created, 'MMM DD, YYYY')}</small>
                  </div>
                </div>
              )
            })}
          </div>}
        </DialogContent>
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    buyerId: state.modalHandler.buyerId,
    showReview: state.modalHandler.showReview,
    address: state.modalHandler.address
  };
};

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(AddRealtorModal);
